package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.SeoStatementBigStyle
import com.anjuros.website.redesign.styles.SeoStatementStackStyle
import com.anjuros.website.redesign.styles.SeoStatementStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** Dark band with one big statement: why SEO matters. */
@Composable
fun SeoStatementSection() {
    RdSection(modifier = SeoStatementStyle.toModifier(), wrapModifier = SeoStatementStackStyle.toModifier()) {
        RdEyebrow(RdText.SEO_STATEMENT_EYEBROW)
        P(SeoStatementBigStyle.toModifier().toAttrs()) {
            Text(LocalText(RdText.SEO_STATEMENT_START))
            Span { Text(LocalText(RdText.SEO_STATEMENT_MARK)) }
        }
        P { Text(LocalText(RdText.SEO_STATEMENT_TEXT)) }
    }
}
